import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SearchFilter } from '../search-filter';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../app/commonReducer';

class SearchBox extends Component {
  clickItemSearch = currentSearch => {
    const { changeCode } = this.props;

    changeCode(currentSearch);
  };

  getCurrentSearch = () => {
    const {
      listCompanyGroupByComGroupCode,
      listOrganizationByOrganCode,
      currentSearch,
    } = this.props;

    return (
      { ...listOrganizationByOrganCode, ...listCompanyGroupByComGroupCode }[
        currentSearch.code
      ] || currentSearch
    );
  };

  render() {
    return (
      <SearchFilter
        schema={[
          { key: 'displayCode', className: 'w-20' },
          { key: 'codeName', className: 'w-55 text-truncate' },
          {
            key: 'exchange',
            className: 'w-25 text-right',
            render: text => {
              return text.toUpperCase();
            },
          },
        ]}
        listKeyFilter={['displayCode', 'codeName']}
        getListSearchFromRedux={state => [
          ...state[COMMON_REDUCER_NAME].listOrganizationSearch,
          ...state[COMMON_REDUCER_NAME].listCompanyGroup,
        ]}
        currentSearch={this.getCurrentSearch()}
        sortKey={'displayCode'}
        mainKey={'code'}
        clickItemSearch={this.clickItemSearch}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    listCompanyGroupByComGroupCode:
      state[COMMON_REDUCER_NAME].listCompanyGroupByComGroupCode,
  };
};

SearchBox.propTypes = {
  currentSearch: PropTypes.object.isRequired,
  changeCode: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(SearchBox);
